import { render, staticRenderFns } from "./HotWaterTable.vue?vue&type=template&id=99f7bf88&scoped=true&"
import script from "./HotWaterTable.vue?vue&type=script&lang=js&"
export * from "./HotWaterTable.vue?vue&type=script&lang=js&"
import style0 from "./HotWaterTable.vue?vue&type=style&index=0&id=99f7bf88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f7bf88",
  null
  
)

export default component.exports